const hero = (): void => {
  const heroSections = document.querySelectorAll<HTMLElement>('[data-hero]');

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    heroSections.forEach((section) => {
      section.setAttribute('data-hero-animated', '');
    });
    return;
  }

  heroSections.forEach((section) => {
    // Small delay to let the page settle, then trigger the fall-in
    requestAnimationFrame(() => {
      setTimeout(() => {
        section.setAttribute('data-hero-animated', '');
      }, 100);
    });
  });
};

export default hero;
